export default "__VITE_ASSET__CERg1dbR__"